import axios from "axios";

const MY_SERVER = '/api/'

export function exploreDare(gender, player, usedid, selectedaccessories, sessionid){

    return axios
    .get(MY_SERVER + 'randomexploredarebygender/', {
        params: { gender, player, usedid, selectedaccessories, sessionid },
        withCredentials: true,
    })
    .then((res) => res.data) // ✅ Directly return the response data
    .catch((error) => {
        console.error('Error fetching dare:', error);
        throw error; // ✅ Ensure error is thrown for handling
    });
    
}

